<template>
  <v-container id="products" fluid tag="section">
    <base-v-component :heading="$t('products-title')" :subtitle="$t('products-subtitle')" />
    <!--
    <v-container>
      <v-row align="center">
        <v-col class="text-center">
          <v-btn color="primary" @click="onCreateItem()">{{ $t('create-new-product') }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    -->

    <div class="d-flex align-baseline">
      <v-tooltip bottom class="flex-column">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            small
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="onCreateItem"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          </template>
        <span>{{ $t('create-new-product') }}</span>
      </v-tooltip>

      <v-tooltip bottom class="flex-column">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            :disabled="!selected.length"
            small
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="dialogConfirmDelete=true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          </template>
        <span>{{ $t('delete') }}</span>
      </v-tooltip>
      
      <!--
      <v-text-field
        v-model="search"
        class="flex-column pl-2"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      />
      -->
      <v-autocomplete
          v-model="searchSelectId"
          :loading="searchLoading"
          :disabled="totalItems<=10"
          :items="searchItems"
          item-text="productName"
          item-value="objectID"
          cache-items
          class="flex-column pl-2"
          flat
          hide-no-data
          hide-details
          append-icon="mdi-magnify"
          label="Search"
          solo-inverted
          @update:search-input="querySearch"
        >
          <template
            slot="item"
            slot-scope="data"
          >
            {{data.item.productName}}
          </template>
        </v-autocomplete><!-- :search-input.sync="search" -->
    </div>

    <!-- DATA TABLE -->
    <template>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="products"
          :loading="fetchLoading"
          :options.sync="tableOptions"
          class="elevation-1 pa-3 clickable"
          :dense="false"
          :calculate-widths="true"
          :loading-text="$t('products-loading')"
          :show-select="true"
          :hide-default-footer="true"
          :disable-pagination="true"
          @click:row="onRowClick"
          v-model="selected"
        >
          <template v-slot:[`item.tags`]="{item}">
            <v-chip v-for="(tag,index) in item.tags" :key="index" class="mr-2">{{ tag }}</v-chip>
          </template>
          <template
            v-slot:[`item.updated`]="{item}"
          >{{ $moment(new Date(item.updated)).format('YYYY-MM-DD') }}</template>
          <template v-slot:[`item.status`]="{item}">{{ $t(item.status) }}</template>
          <template v-slot:[`item.notes`]="{ item }">
            <v-tooltip v-if="hasMissingEvaluation(item)" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" small color="red" class="mr-2">mdi-exclamation-thick</v-icon>
              </template>
              <span>Product has ingredient without evaluation</span>
            </v-tooltip>
            <v-tooltip v-if="hasProhibited(item)" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" small class="mr-2" color="red">mdi-alert</v-icon>
              </template>
              <span>Product has prohibited ingredient (Annex 2)</span>
            </v-tooltip>
            <v-tooltip v-if="hasRestricted(item)" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" small class="mr-2">mdi-alert-circle-outline</v-icon>
              </template>
              <span>Product has restricted ingredient (Annex 3)</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.options`]="{item}">
            <v-menu 
              transition="slide-x-transition"
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="no-background primary--text"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(option, index) in options"
                  :key="index"
                  @click="onOption(option.id, item)"
                >
                  <v-list-item-title>{{ option.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:footer>
          <section class="my-6 text-center">
              <v-btn
                v-if="totalItems>products.length && !fetchLoading"
                color="primary"
                text
                @click="loadMore()"
                :disabled="fetchLoading || totalItems<=products.length"
              >
                Load more
              </v-btn>
          </section>
        </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- DIALOG CONFIRM DELETE -->
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete-multiple-items') }}</v-card-title>
        <v-card-text>{{ $t('delete-multiple-items-confirm') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmDelete = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" text @click="onDeleteMultipleItems">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CONFIRM DELETE ITEM -->
    <v-dialog v-model="dialogDeleteItem" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete-product') }}</v-card-title>
        <v-card-text>{{ $t('delete-product-confirm') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDeleteItem = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" text @click="onDeleteItem">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG REPORT WARNING -->
    <v-dialog v-model="dialogCreateReportWarning" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('product-missing-safety-evaluation') }}</v-card-title>
        <v-card-text>{{ $t('product-missing-safety-evaluation-description') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCreateReportWarning = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" text @click="dialogCreateReportWarning = false, dialogCreateReport = true">{{ $t('continue') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG REPORT -->
    <v-dialog v-model="dialogCreateReport" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('create-report') }}</v-card-title>
        <v-card-text>
          <v-container>
            <p>{{ $t('create-report-description')}}</p>
            <v-row>
              <v-col>
                <v-select
                  v-model="item.templatePath"
                  :items="templates"
                  :label="$t('template')"
                  item-text="name"
                  item-value="fullPath"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCreateReport = false">{{ $t('cancel') }}</v-btn>
          <v-btn primary text @click="createReport">{{ $t('confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  name: "Products",

  components: {},

  data: () => ({
    headers: [
      {
        text: "Article",
        align: "start",
        value: "productArticleNumber",
      },
      { text: "Name", value: "productName" },
      { text: "Category", value: "category" },
      { text: "Status", value: "status" },
      { text: "Tags", value: "tags" },
      { text: "Updated", value: "updated" },
      {
        text: "",
        value: "notes",
        sortable: false,
        width: "10%",
        align: "right",
      },
      {
        text: "",
        value: "options",
        sortable: false,
        width: "2%",
        align: "right",
      },
    ],
    options: [
      {
        title: 'Generate Report',
        id: 'report'
      },
      {
        title: 'Edit',
        id: 'edit'
      },
      {
        title: 'Duplicate',
        id: 'duplicate'
      },
      {
        title: 'Delete',
        id: 'delete'
      },
    ],

    sortedBy: 'updated',
    sortedDesc: true,

    tableOptions: {},
    fetchLoading: false,
    totalItems: 0,
    limit: 10,

    // search
    searchLoading: false,
    searchItems: [],
    search: null,
    searchSelectId: null,

    item: [],
    selected: [],
    dialogCreateReportWarning: false,
    dialogCreateReport: false,
    dialogConfirmDelete: false,
    dialogDeleteItem: false,
  }),


  created() {
    if (this.activeProject && this.activeProject.id) {
      this.setTotalProjectItems(this.activeProject)
      if (this.products.length<this.limit) {
        this.loadMore();
      }
    }
  },

  watch: {
    tableOptions: {
      handler () {
        if (this.activeProject && this.activeProject.id) {
          if (this.tableOptions && this.tableOptions.sortBy && this.tableOptions.sortDesc) {
            if (this.tableOptions.sortBy[0] != this.sortedBy || this.tableOptions.sortDesc[0] != this.sortedDesc) {
              this.sortedBy = this.tableOptions.sortBy[0];
              this.sortedDesc = this.tableOptions.sortDesc[0]
              this.clearFetch();
            }
          }
        }
      },
      deep: true,
    },
    activeProject: function () {
      this.setTotalProjectItems();
      this.clearFetch();
    },
    searchSelectId: function (newId) {
      if (newId) {
        this.$router.push({
          name: "products.edit",
          params: { id: newId },
        });
      }
    },
  },

  computed: {
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
    access() {
      return this.$store.getters["company/getAccess"];
    },
    products() {
      return this.$store.getters["products/getProducts"];
    },
    projectIngredients() {
      return this.$store.getters["projectIngredients/getProjectIngredients"];
    },
    templates() {
      return this.$store.getters["templates/getTemplates"];
    },
  },

  methods: {
    setTotalProjectItems() {
      const project = this.activeProject;
      this.totalItems = project.quantity && project.quantity.products ? project.quantity.products : 0;
    },
    loadMore() {
      if (this.totalItems>this.products.length) {
        this.fetchProducts();
      }
    },
    async clearFetch() {
      await this.$store.dispatch("products/clearProducts")
      this.fetchProducts();
    },
    fetchProducts() {
      this.fetchLoading = true;
      this.$store.dispatch("products/fetchProducts", { projectId: this.activeProject.id, options: this.tableOptions })
        .then(() => {
          this.fetchLoading = false;
        })
        .catch((error) => {
          console.log(error)
          this.fetchLoading = false;
        })
    },
    async querySearch(search) {
      if (search && search.length >= 2) {
        this.$searchService.querySearch('project_products', search)
          .then((res) => {
            this.searchItems = res;
          })
      }
    },
    isProhibited (item) {
      return this.$store.getters["ingredients/isProhibited"](item);
    },
    isRestricted (item) {
      return this.$store.getters["ingredients/isRestricted"](item);
    },
    hasProjectIngredient(item) {
      if (!this.projectIngredients) return false;
      const index = this.projectIngredients.findIndex(
        (obj) => obj.reference === item.reference || obj.casNumber === item.casNumber || obj.inciName === item.inciName
      );
      return index > -1 ? true : false;
    },
    customFilter(item, queryText) {
      const textOne = item.inciName.toLowerCase();
      const textTwo = item.casNumber.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    onRowClick(item) {
      this.onEditItem(item);
    },
    onOption(option, item) {
      this.item = JSON.parse(JSON.stringify(item))
      if (option === 'edit') {
        this.onEditItem(this.item)
      }
      else if (option==='delete') {
        this.dialogDeleteItem = true;
      }
      else if (option === 'duplicate') {
        this.onDuplicateItem(this.item)
      }
      else if (option === 'report') {
        if (this.hasMissingEvaluation(this.item)) {
          this.dialogCreateReportWarning = true;
        } else {
          this.dialogCreateReport = true;
        }
      }
    },
    onCreateItem() {
      if (!this.activeProject) {
        this.$notify({
          group: "base",
          type: "error",
          title: "No active Workspace",
          text: "You need to select a Workspace, or create one in Account",
        });
        return null;
      }
      if (!this.access.products) {
        this.$emit('showSnackbar', {
          text: "You've reached the limit for your subscription plan.",
          button: "Upgrade",
          routeTo: "account",
        });
        return null;
      }
      this.$router.push("products/create");
    },
    onEditItem(item) {
      this.$router.push({ name: "products.edit", params: { id: item.id } });
    },
    onDuplicateItem(item) {
      this.$router.push({ 
        name: "products.edit", 
        params: { 
          id: item.id,
          duplicate: true,
        } 
      });
    },
    onDeleteMultipleItems () {
      if (this.activeProject.id) {
        this.$store
          .dispatch(
            "products/deleteMultipleItems",
            this.selected
          )
          .then(() => {
            this.$notify({
              group: "base",
              type: "success",
              title: "Items deleted",
              text: "The selected items has been successfully deleted.",
            });
            this.dialogConfirmDelete = false;
            this.selected = [];
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text: "The items has not been deleted. Please try again.",
            });
            this.dialogConfirmDelete = false;
          });
      }
    },
    hasRestricted(product) {
      const arr = product.ingredients.map((item) => {
        if (!item || !item.casNumber || item.casNumber === "") return false;
        if (item.restriction != '' && typeof item.restriction != 'undefined') return true;
        return this.$ingredientService.cosingRestricted.some((cos) => {
          return cos.casNumber.includes(item.casNumber)
        });
      });
      return arr.includes(true);
    },
    hasProhibited(product) {
      const arr = product.ingredients.map((item) => {
        if (!item || !item.casNumber || item.casNumber === "" || typeof item.casNumber == 'undefined') return false;
        return this.$ingredientService.cosingProhibited.some((cos) => {
          return cos.casNumber.includes(item.casNumber)
        });
      });
      return arr.includes(true);
    },
    hasMissingEvaluation(product) {
      const arr = product.ingredients.map((item) => {
        return item.id || this.hasProjectIngredient(item)
      });
      return arr.includes(false);
    },
    onDeleteItem () {
      this.$store.dispatch('products/deleteProduct', this.item)
        .then(() => {
          this.$notify({
            group: "base",
            type: "success",
            title: "Item delete",
            text: "The item has been successfully deleted.",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "base",
            type: "error",
            title: "Oops, something went wrong",
            text: "The item has not been deleted. Please try again.",
          });
        });
      this.dialogDeleteItem = false;
    },
    createReport() {
      if (this.item.templatePath) {
        this.$store
          .dispatch("reports/generateDoc", this.item)
          .then(() => {
            this.dialogCreateReport = false;
            this.$notify({
              group: "base",
              type: "success",
              title: "Report successfully generated",
              text: "Your report document will soon start to download.",
            });
          })
          .catch((error) => {
            console.error(error);
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text: "That did not go according to plan. Please try again.",
            });
          });
      } else {
        this.$notify({
          group: "base",
          type: "info",
          title: "You forgot something...",
          text: "Pick a template to generate the report",
        });
      }
    },
    onCreateReport (item) {
      this.resetEditingObject()
      this.setEditingObject(item)
      this.dialogCreateReport = true
    },
  },
};
</script>

<style>
.v-chip {
  max-width: 150px !important;
  text-overflow: ellipsis;
  display: inline-block;
}
.clickable table > tbody > tr {
  cursor: pointer;
}
</style>